import React, { useEffect, useState, useContext } from "react";

import { SafeAreaView, TouchableOpacity } from "react-native";

import AppContext from "../../../../appContext";
import HomeIcon from "./icons/HomeIcon";
import ReflectionIcon from "./icons/ReflectionIcon";
import ResolutionIcon from "./icons/ResolutionIcon";
import styles from "./footerStyles";
import TrackIcon from "./icons/TrackIcon";
import TutorialsHelper from "../../tutorials/TutorialsHelper";
import TeamIcon from "./icons/TeamIcon";
import appPages from "../../../../appPages";

export default function Footer(props) {
  const { controller } = useContext(AppContext) || {};
  const [showTutorials, setShowTutorials] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { navigation, state } = props;
  const { navigate } = navigation;
  const focused = controller?.state?.focusedTab;

  useEffect(() => {
    setShowTutorials(
      TutorialsHelper.isTutorialMode(controller?.state?.showTutorials),
    );
  }, [controller?.state?.showTutorials]);

  useEffect(() => {
    setSelectedIndex(state?.index);
  }, [props?.state?.index]);

  const goto = (page) => {
    if (showTutorials && !focused) return;
    if (focused && focused != page) return; // for tutorials

    controller.setState({ focusedTab: "" });
    navigate(page);
  };

  return (
    <SafeAreaView style={styles.base}>
      {/* <View style={styles.base}> */}
      {/* Home */}
      <TouchableOpacity
        onPress={() => goto("feed")}
        style={styles.pill}
      >
        <HomeIcon isSelected={selectedIndex === 0} />
      </TouchableOpacity>

      {/* Track */}
      <TouchableOpacity
        onPress={() => goto(appPages.trackHome)}
        style={styles.pill}
      >
        <TrackIcon isSelected={selectedIndex === 1} />
      </TouchableOpacity>

      {/* Reflection */}
      <TouchableOpacity
        onPress={() => goto(appPages.reflectionPage)}
        style={styles.pill}
      >
        <ReflectionIcon isSelected={selectedIndex === 2} />
      </TouchableOpacity>

      {/* Goals */}
      <TouchableOpacity
        onPress={() => goto(appPages.resolutionPage)}
        style={styles.pill}
      >
        <ResolutionIcon
          isSelected={selectedIndex === 3}
          style={
            focused == appPages.resolutionPage ? styles.highlightFooter : {}
          }
        />
      </TouchableOpacity>

      {/* Reports */}
      <TouchableOpacity
        onPress={() => goto(appPages.receivedReports)}
        style={styles.pill}
      >
        <TeamIcon isSelected={selectedIndex === 4} />
      </TouchableOpacity>
      {/* </View> */}
    </SafeAreaView>
  );
}
